import {XivLang} from "./types";

export class NavigationHandler {
    private navigationHashCache: string | null = null;

    public subscribe(onChange: (lang: XivLang, search: string) => void) {
        window.addEventListener("hashchange", () => {
            if (this.navigationHashCache !== window.location.hash) {
                const nav = this.getSearchFromNavigation(true);
                if (nav) {
                    onChange(nav.language as XivLang, nav.search);
                }
            }
        })
    }

    public getSearchFromNavigation = (forceRefresh?: boolean) => {
        let hash = '';
        if (forceRefresh) {
            hash = window.location.hash;
        } else {
            hash = this.navigationHashCache ?? window.location.hash;
        }

        if (hash) {
            if (hash.includes('/search/')) {
                const search = decodeURIComponent(hash.substr('/search/'.length + 1));
                const matches = search.match(/^\/?(?<language>fr|en|ja|de)*\/(?<search>.+)/);
                if (matches) {
                    const searchTerm = matches.groups?.search.trim();
                    if (searchTerm && searchTerm.length > 0) {
                        return {
                            language: matches.groups?.language ?? "en",
                            search: searchTerm
                        }
                    }
                }
            }
        }

        return null;
    };

    public setSearchInNavigation = (lang: XivLang, search: string) => {
        this.navigationHashCache = `/search/${lang}/${encodeURIComponent(search)}`;
        window.location.hash = this.navigationHashCache;
    }
}